import { CustomPermissions } from 'terra-react'

export const SUFFICIENT_PERMISSIONS = [
  CustomPermissions.WEIGHT,
  CustomPermissions.STEPS,
  CustomPermissions.FLIGHTS_CLIMBED,
  CustomPermissions.EXERCISE_DISTANCE,
  CustomPermissions.SLEEP_ANALYSIS,
  CustomPermissions.WORKOUT_TYPES,
  CustomPermissions.BLOOD_GLUCOSE,
]
